import { environment } from '../../../environments/environment';

/**
 * Whether a request goes to be-extranet-service: the API base itself or a path below it. The interceptors attach the
 * bearer token and the admin view-as header only to such a request.
 *
 * Since AB#4431 the base is a bare host (`https://api.extranet.hilbertech.com`, no `/api` path any more), so a plain
 * `startsWith` would also match another host that merely begins with it (`https://api.extranet.hilbertech.com.example`)
 * and hand it the token. A presigned photo upload (Azure Blob Storage) is never such a request.
 */
export function isApiUrl(url: string, base: string = environment.apiBaseUrl): boolean {
  const root = base.endsWith('/') ? base.slice(0, -1) : base;
  if (url === root) return true;
  return ['/', '?', '#'].some(separator => url.startsWith(root + separator));
}
